<template>
  <v-fade-transition mode="out-in">
    <v-card
      dark      
      :key="$route.path"
    >
      <v-img
        :height="isHome ? '40vh' : '20vh'"
        :src="namespace === 'Login' ? '' : `static/${namespace.toLowerCase()}-jumbotron.jpg`"
        gradient="to top, rgba(13, 3, 29, .25), rgba(25, 25, 38, .85)">
        <v-fade-transition mode="out-in">
          <v-container
            fill-height
            :key="$route.path"
          >
            <v-layout align-center>
              <v-fade-transition mode="out-in">
                <v-flex
                  text-xs-center
                  :key="$route.path"
                >
                  <h1 
                    v-if="$vuetify.breakpoint.mdAndUp"
                    class="display-1" 
                    v-html="title" />
                  <h1 
                    v-else
                    class="subheading"
                    v-html="title" />
                  <div
                    class="subheading"
                    v-html="subTitle"
                    v-if="subTitle && $vuetify.breakpoint.mdAndUps"
                  />                  
                  <UserAccess
                    v-if="isHome" />
                </v-flex>
              </v-fade-transition>
            </v-layout>
          </v-container>
        </v-fade-transition>
      </v-img>
    </v-card>
  </v-fade-transition>
</template>

<script>
export default {
  data: () => ({}),

  computed: {
    isHome() {
      return this.$route.path === "/";
    },
    namespace() {
      const path = this.$route.path.split("/")[1];

      return this.isHome
        ? "Home"
        : `${path.substr(0, 1).toUpperCase()}${path.slice(1)}`;
    },
    title() {
      return this.$store.getters.getConfig.title;
    },
    subTitle() {
      return this.$store.getters.getConfig.subtitle;
    }
  }
};
</script>
